import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const getToken = () =>
    localStorage.getItem("authToken") ||
    localStorage.getItem("token");

const headers = () => ({
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
});

// GET Incentives
export const getIncentives = async () => {
    const response = await axios.get(
        `${BASE_URL}/delivery/api/get/admin/incentives`,
        {
            headers: headers(),
        }
    );

    return response.data;
};

// POST Incentive
export const createIncentive = async (data) => {

    const response = await axios.post(
        `${BASE_URL}/delivery/api/admin/add/incentives`,
        data,
        {
            headers: headers(),
        }
    );

    return response.data;
};

export const getIncentiveSlabs = async (id) => {
    const response = await axios.get(
        `${BASE_URL}/delivery/admin/incentives/${id}/slabs`,
        {
            headers: headers(),
        }
    );

    return response.data;
};

export const createIncentiveSlab = async (data) => {
    const response = await axios.post(
        `${BASE_URL}/delivery/admin/incentives/${data.incentiveId}/slabs`,
        data,
        {
            headers: headers(),
        }
    );

    return response.data;
};

